import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import TranslateIcon from '@mui/icons-material/TranslateRounded';
import Button from '@components/Button';
import { useTranslation } from '@hooks';
import LocalizeItemModal from './index';
import LocalizedFieldInput from './LocalizedFieldInput';

const LocalizedTexts = ({ fields, currentLocale, isView, entity = 'texts', additionalRowsOptional = false }) => {
    const [isLocalizeOpen, setIsLocalizeOpen] = useState(false);
    const [touched, setTouched] = useState({});
    const { t } = useTranslation();
    const { watch, setValue } = useFormContext();

    const texts = watch(entity);
    const primary = texts.find(text => text.language === currentLocale) || texts[0];

    if (!primary) return null;

    const touch = name => setTouched(prev => (prev[name] ? prev : { ...prev, [name]: true }));

    const onChange = e => {
        const nextTexts = texts.map(text =>
            text.language === primary.language ? { ...text, [e.target.name]: e.target.value } : text,
        );
        setValue(entity, nextTexts, { shouldDirty: true, shouldValidate: true });
        touch(e.target.name);
    };

    return (
        <div style={{ marginTop: 8 }}>
            {fields.map(field => (
                <LocalizedFieldInput
                    key={field.name}
                    field={field}
                    value={primary[field.name]}
                    onChange={onChange}
                    onBlur={() => touch(field.name)}
                    touched={!!touched[field.name]}
                    disabled={isView}
                />
            ))}
            <Button
                variant="outlined"
                startIcon={<TranslateIcon />}
                onClick={() => setIsLocalizeOpen(true)}
                disabled={isView}
            >
                {t('buttons.localization')}
            </Button>
            {isLocalizeOpen ? (
                <LocalizeItemModal
                    modal={{ open: true }}
                    entity={entity}
                    fields={fields}
                    currentLocale={currentLocale}
                    withChangeTitle={false}
                    additionalRowsOptional={additionalRowsOptional}
                    onClose={() => setIsLocalizeOpen(false)}
                />
            ) : null}
        </div>
    );
};

export default LocalizedTexts;
